<template>
  <brand-aggregate-page
    storage-key="taofukeBrandListData"
    default-title="十节优选"
    empty-icon="🛍️"
  />
</template>

<script>
import BrandAggregatePage from './BrandAggregatePage.vue';

export default {
  name: 'TaofukeBrandList',
  components: { BrandAggregatePage },
};
</script>
